const lv = {
  brand: "E2 Care",
  tagline: "Mierīga, savienota aprūpe.",
  nav_dashboard: "Pārskats",
  nav_residents: "Pacienti",
  nav_patients: "Pacienti",
  nav_rooms: "Telpas",
  nav_devices: "Ierīces",
  nav_events: "Notikumi",
  nav_alerts: "Brīdinājumi",
  nav_users: "Komanda",
  nav_settings: "Iestatījumi",
  nav_admin: "Administrēšana",
  nav_signout: "Iziet",
  topbar_search_placeholder: "Meklēt pacientus, telpas, ierīces…",
  admin_super_only: "Tikai super-administratori var pārvaldīt organizācijas.",
  admin_admin_only: "Tikai administratori var piekļūt šai lapai.",
  admin_tab_orgs: "Organizācijas",
  admin_tab_users: "Lietotāji",
  admin_tab_patients: "Pacienti",
  admin_tab_rooms: "Telpas",
  admin_tab_buildings: "Ēkas",
  admin_tab_devices: "Ierīces",
  admin_tab_alerts: "Brīdinājumi",
  admin_tab_qa: "Testa rīki",
  admin_delete: "Dzēst",
  admin_no_orgs_yet: "Vēl nav organizāciju.",
  admin_field_name: "Nosaukums",
  admin_field_email: "E-pasts",
  admin_field_phone: "Tālrunis",
  admin_field_password: "Parole",
  admin_field_role: "Loma",
  admin_field_type: "Tips",
  admin_field_timezone: "Laika josla",
  admin_field_address: "Adrese",
  admin_field_status: "Statuss",
  admin_field_organization: "Organizācija",
  admin_password_keep: "Atstājiet tukšu, lai saglabātu",
  admin_field_birth_date: "Dzimšanas datums",
  admin_field_room: "Telpa",
  admin_field_room_none: "Nepiešķirts",
  admin_field_photo: "Foto URL",
  admin_field_photo_hint: "Ielīmējiet publisku URL — augšupielāde v2.",
  admin_field_notes: "Aprūpētāja piezīmes",
  admin_field_emergency_contact: "Galvenais ārkārtas kontakts",
  admin_field_ec_name: "Vārds",
  admin_field_ec_phone: "Tālrunis",
  admin_field_ec_relationship: "Attiecības",
  admin_field_mac: "MAC adrese",
  admin_field_firmware: "Programmaparatūra",
  admin_field_assignment: "Piesaistīts",
  admin_field_assigned_room: "Piesaistītā telpa",
  admin_field_assigned_patient: "Piesaistītais pacients",
  admin_field_assigned_hint: "Pēc izvēles. Sensori — telpai; aproces — pacientam.",
  admin_field_sensor_target: "Piestiprināts pie",
  admin_field_sensor_target_hint: "Norāda sistēmai, vai šis sensors uzrauga durvis vai logu.",
  sensor_target_door: "Durvis",
  sensor_target_window: "Logs",
  sensor_target_unset: "Nav konfigurēts",
  admin_field_sensor_label: "Sensora etiķete",
  admin_field_sensor_label_hint: "Draudzīgs nosaukums, kas redzams brīdinājumos un notikumos — piem., „Priekšējās durvis“, „Vannas istabas logs“.",
  admin_field_building: "Ēka",
  admin_field_building_required: "Istabai jāpieder ēkai.",
  room_openings: "Ailas",
  room_no_openings: "Šajā istabā vēl nav uzstādīti durvju vai logu sensori.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Pēdējās izmaiņas",
  admin_field_description: "Apraksts",
  admin_field_severity: "Smagums",
  admin_field_patient: "Pacients",
  admin_field_device: "Ierīce",
  admin_field_message: "Ziņojums",
  admin_orgs_title: "Organizācijas",
  admin_orgs_sub: "Izveidojiet, rediģējiet un arhivējiet E2 Care nomniekus.",
  admin_orgs_count: "organizācijas",
  admin_org_new: "Jauna organizācija",
  admin_org_new_title: "Jauna organizācija",
  admin_org_edit_title: "Rediģēt organizāciju",
  admin_org_created: "Organizācija izveidota.",
  admin_org_updated: "Organizācija atjaunināta.",
  admin_org_deleted: "Organizācija arhivēta.",
  admin_org_delete_title: "Arhivēt organizāciju?",
  admin_org_delete_confirm: "\"{name}\" tiks paslēpta no sarakstiem.",
  admin_users_title: "Lietotāji",
  admin_users_sub_super: "Pārvaldiet visus lietotāju kontus.",
  admin_users_sub_org: "Pārvaldiet lietotāju kontus {org}.",
  admin_user_new: "Jauns lietotājs",
  admin_user_new_title: "Jauns lietotājs",
  admin_user_edit_title: "Rediģēt lietotāju",
  admin_user_created: "Lietotājs izveidots.",
  admin_user_updated: "Lietotājs atjaunināts.",
  admin_user_deleted: "Lietotājs arhivēts.",
  admin_user_delete_title: "Arhivēt lietotāju?",
  admin_user_delete_confirm: "\"{name}\" zaudēs piekļuvi.",
  admin_user_memberships: "Organizāciju dalība",
  admin_patients_title: "Pacienti",
  admin_patients_sub_super: "Pārvaldiet visus pacientu ierakstus.",
  admin_patients_sub_org: "Pārvaldiet pacientus {org}.",
  admin_patient_new: "Jauns pacients",
  admin_patient_new_title: "Jauns pacients",
  admin_patient_edit_title: "Rediģēt pacientu",
  admin_patient_created: "Pacients izveidots.",
  admin_patient_updated: "Pacients atjaunināts.",
  admin_patient_deleted: "Pacients arhivēts.",
  admin_patient_delete_title: "Arhivēt pacientu?",
  admin_patient_delete_confirm: "\"{name}\" tiks paslēpts no sarakstiem.",
  admin_rooms_title: "Telpas",
  admin_rooms_sub_super: "Konfigurējiet telpas.",
  admin_rooms_sub_org: "Konfigurējiet telpas {org}.",
  admin_room_new: "Jauna telpa",
  admin_room_new_title: "Jauna telpa",
  admin_room_edit_title: "Rediģēt telpu",
  admin_room_created: "Telpa izveidota.",
  admin_room_updated: "Telpa atjaunināta.",
  admin_room_deleted: "Telpa arhivēta.",
  admin_room_delete_title: "Arhivēt telpu?",
  admin_room_delete_confirm: "\"{name}\" tiks paslēpta.",
  admin_devices_title: "Ierīces",
  admin_devices_sub_super: "Pievienojiet Moko ierīces.",
  admin_devices_sub_org: "Pievienojiet Moko ierīces {org}.",
  admin_device_new: "Jauna ierīce",
  admin_device_new_title: "Jauna ierīce",
  admin_device_edit_title: "Rediģēt ierīci",
  admin_device_created: "Ierīce izveidota.",
  admin_device_updated: "Ierīce atjaunināta.",
  admin_device_deleted: "Ierīce arhivēta.",
  admin_device_delete_title: "Arhivēt ierīci?",
  admin_device_delete_confirm: "Ierīce {mac} tiks paslēpta.",
  admin_buildings_title: "Ēkas",
  admin_buildings_sub_super: "Grupējiet telpas pa ēkām.",
  admin_buildings_sub_org: "Grupējiet telpas pa ēkām {org}.",
  admin_building_new: "Jauna ēka",
  admin_building_new_title: "Jauna ēka",
  admin_building_edit_title: "Rediģēt ēku",
  admin_building_created: "Ēka izveidota.",
  admin_building_updated: "Ēka atjaunināta.",
  admin_building_deleted: "Ēka arhivēta.",
  admin_building_delete_title: "Arhivēt ēku?",
  admin_building_delete_confirm: "\"{name}\" tiks paslēpta.",
  admin_qa_title: "Testa rīki",
  admin_qa_sub: "Ievadiet notikumus, lai pārbaudītu plūsmu.",
  admin_qa_event_title: "Ievadīt testa notikumu",
  admin_qa_event_sub: "Simulē Moko webhook.",
  admin_qa_alert_title: "Ievadīt testa brīdinājumu",
  admin_qa_alert_sub: "Apej notikumu līmeni.",
  admin_qa_inject_event: "Ievadīt notikumu",
  admin_qa_inject_alert: "Ievadīt brīdinājumu",
  admin_qa_event_done: "Notikums ievadīts.",
  admin_qa_alert_done: "Brīdinājums ievadīts.",
  admin_qa_disclaimer: "Šiem galapunktiem ražošanā jābūt deaktivizētiem.",
  admin_alerts_title: "Brīdinājumu politika",
  admin_alerts_sub: "Organizācijas mēroga brīdinājumu noteikumi: {org}.",
  admin_alerts_quiet_title: "Klusās stundas",
  admin_alerts_quiet_desc: "Norādiet, kad šī organizācija ir nakts režīmā.",
  admin_alerts_quiet_hint: "Laiks tiek interpretēts organizācijas vietējā laika joslā. Intervāls drīkst pāriet pāri pusnaktij (piem. 22:00 → 06:00).",
  admin_alerts_night_start: "Nakts sākas",
  admin_alerts_night_end: "Nakts beidzas",
  admin_alerts_load_failed: "Ielādēt brīdinājumu politiku",
  admin_alerts_save_failed: "Saglabāt brīdinājumu politiku",
  admin_alerts_saved: "Brīdinājumu politika saglabāta.",
  admin_alerts_clear_title: "Notīrīt aktīvos brīdinājumus",
  admin_alerts_clear_desc: "Vienā klikšķī apstipriniet visus atvērtos brīdinājumus šajā organizācijā.",
  admin_alerts_clear_hint: "Apstiprinātie brīdinājumi paliek vēsturē.",
  admin_alerts_ack_all_button: "Apstiprināt visus",
  admin_alerts_ack_all_title: "Apstiprināt visus aktīvos brīdinājumus?",
  admin_alerts_ack_all_confirm: "Tas apstiprinās katru atvērto brīdinājumu šeit: {org}. Šo darbību nevar atsaukt.",
  admin_alerts_ack_all_done: "Apstiprināti {count} brīdinājumi.",
  admin_alerts_ack_all_done_generic: "Visi aktīvie brīdinājumi apstiprināti.",
  admin_alerts_ack_all_failed: "Apstiprināt visus brīdinājumus",
  org_type_nursing_home: "Pansionāts",
  org_type_assisted_living: "Aprūpes māja",
  org_type_hospital: "Slimnīca",
  org_type_home_care: "Mājas aprūpe",
  role_admin: "Administrators",
  role_caregiver: "Aprūpētājs",
  role_family: "Ģimene",
  status_active: "aktīvs",
  status_inactive: "neaktīvs",
  confirm: "Apstiprināt",
  sign_in: "Ieiet",
  signed_in: "Pieteicies",
  sign_up: "Reģistrēties",
  email: "E-pasts",
  password: "Parole",
  full_name: "Pilns vārds",
  create_account: "Izveidot kontu",
  no_account: "Vēl nav konta?",
  have_account: "Jau ir konts?",
  login_welcome: "Laipni lūdzam atpakaļ",
  login_sub: "Ieiet, lai turpinātu uzraudzīt iedzīvotājus.",
  register_welcome: "Pievienojies E2 Care",
  register_sub: "Izveido darba vietu minūtē.",
  total_residents: "Pacienti",
  active_devices: "Aktīvas ierīces",
  open_alerts: "Atvērti brīdinājumi",
  offline_gateways: "Bezsaistes ierīces",
  falls_7d: "Kritieni (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Zems akumulators",
  critical_residents: "Kritiski",
  status_ok: "Viss kārtībā",
  status_warning: "Uzmanību",
  status_critical: "Kritiski",
  status_online: "Tiešsaistē",
  status_offline: "Bezsaistē",
  search: "Meklēt",
  filter: "Filtrs",
  all: "Visi",
  refresh: "Atjaunot",
  loading: "Ielādē…",
  no_results: "Šeit pagaidām nekā nav.",
  view_profile: "Skatīt profilu",
  showing_n_of_m: "Rāda {n} no {m}",
  load_more: "Ielādēt vairāk",
  auto_refresh: "Tiešsaistē · auto atjauno",
  auto_refresh_paused: "Apturēts",
  updated_just_now: "Atjaunots tikko",
  updated_n_sec_ago: "Atjaunots pirms {n}s",
  updated_n_min_ago: "Atjaunots pirms {n}m",
  acknowledge: "Apstiprināt",
  acknowledged: "Apstiprināts",
  ack_all: "Apstiprināt visus",
  ack_all_confirm: "Apstiprināt visus {count} aktīvos brīdinājumus?",
  ack_all_running: "Apstiprina…",
  ack_all_done: "{count} brīdinājums(-i) apstiprināts.",
  ack_all_partial: "{ok} apstiprināts · {fail} neizdevās.",
  last_seen: "Pēdējo reizi",
  battery: "Akumulators",
  signal: "Signāls",
  firmware: "Programmatūra",
  room: "Telpa",
  age: "Vecums",
  emergency_contact: "Ārkārtas kontakts",
  notes: "Piezīmes",
  assigned_devices: "Piešķirtas ierīces",
  recent_events: "Jaunākie notikumi",
  timeline_24h: "Pēdējās 24 stundas",
  delivery_status: "Piegādes statuss",
  acknowledged_by: "Apstiprināja",
  dashboard_title: "Māju pārskats",
  dashboard_sub: "Ātrs pārskats par aprūpējamām mājām.",
  residents_title: "Pacienti",
  residents_sub: "Cilvēki, kurus šobrīd uzraugāt.",
  devices_title: "Ierīces",
  devices_sub: "Sensori un aproces.",
  devices_sub_admin: "Vārtejas, sensori un aproces.",
  events_title: "Tiešie notikumi",
  events_sub: "Hronoloģiska plūsma.",
  alerts_title: "Brīdinājumi",
  alerts_sub: "Paziņojumi ģimenei un aprūpētājiem.",
  settings_title: "Iestatījumi",
  settings_sub: "Jūsu izvēles.",
  users_title: "Komanda",
  users_sub: "Aprūpētāji, ģimene un administratori.",
  falls_chart_title: "Kritieni un SOS — pēdējās 7 dienās",
  recent_alerts_title: "Jaunākie kritiskie brīdinājumi",
  no_alerts: "Nav atvērtu brīdinājumu. Visi ir drošībā.",
  event_fall: "Atklāts kritiens",
  event_sos: "Nospiesta SOS poga",
  event_door_open: "Atvērtas durvis",
  event_door_close: "Aizvērtas durvis",
  event_inactivity: "Ilgstoša neaktivitāte",
  event_low_battery: "Zems akumulators",
  event_offline: "Ierīce bezsaistē",
  event_online: "Ierīce atkal tiešsaistē",
  event_heartbeat: "Sirdsdarbība",
  event_button_press: "Nospiesta poga",
  device_gateway: "Bluetooth vārteja",
  device_door_sensor: "Durvju sensors",
  device_bracelet: "Aproce",
  device_unknown: "Nezināma ierīce",
  language: "Valoda",
  notifications: "Paziņojumi",
  quiet_hours: "Klusā stunda",
  escalation: "Eskalācijas politika",
  just_now: "tikko",
  rel_prefix: "",
  min_ago: "min atpakaļ",
  h_ago: "st atpakaļ",
  d_ago: "d atpakaļ",
  demo_hint: "Demo konts: admin@e2care.lv / Care2024!",
  open_menu: "Atvērt izvēlni",
  close_menu: "Aizvērt izvēlni",
  care_team: "Aprūpes komanda",
  family_members: "Ģimene",
  no_caregivers: "Vēl nav piešķirts neviens aprūpētājs.",
  no_family: "Vēl nav saistīts neviens ģimenes loceklis.",
  add_caregiver: "Pievienot aprūpētāju",
  add_family: "Pievienot ģimenes locekli",
  select_user: "Izvēlies lietotāju…",
  cancel: "Atcelt",
  add: "Pievienot",
  remove: "Noņemt",
  save: "Saglabāt",
  relationship: "Radniecība",
  relationship_son: "Dēls",
  relationship_daughter: "Meita",
  relationship_spouse: "Laulātais",
  relationship_other: "Cits",
  notify_via: "Paziņot caur",
  call_contact: "Zvanīt",
  view_resident: "Atvērt profilu",
  address: "Adrese",
  admin_only_section: "Administratora rīki",
  rooms_title: "Telpas",
  rooms_sub: "Visas uzraudzītās telpas.",
  room_name: "Telpa",
  room_type: "Tips",
  room_type_private_room: "Privāta telpa",
  room_type_shared_room: "Kopēja telpa",
  room_type_apartment: "Dzīvoklis",
  room_type_corridor: "Gaitenis",
  room_type_common_area: "Koplietošanas telpa",
  room_floor: "Stāvs",
  room_state: "Pašreizējais stāvoklis",
  door: "Durvis",
  window: "Logs",
  door_open_state: "Atvērts",
  door_closed_state: "Aizvērts",
  door_unknown_state: "Nezināms",
  room_no_devices: "Šajā telpā vēl nav ierīču.",
  room_no_patients: "Šajā telpā vēl nav pacientu.",
  room_patients: "Pacienti telpā",
  room_devices: "Ierīces telpā",
  room_activity: "Aktivitātes laika līnija",
  rooms_filter_all_types: "Visi veidi",
  widget_active_alerts: "Aktīvie brīdinājumi",
  widget_active_alerts_sub: "Kritiski, neatrisināti un apstiprināti",
  widget_patients_status: "Pacientu statuss",
  widget_devices_health: "Ierīču veselība",
  widget_room_activity: "Telpu aktivitāte",
  widget_recent_events: "Tiešraides notikumi",
  widget_connectivity: "Savienojamība",
  metric_critical: "Kritiski",
  metric_unresolved: "Neatrisināti",
  metric_acknowledged_count: "Apstiprināti",
  metric_total: "Kopā",
  metric_active: "Aktīvi",
  metric_online: "Tiešsaistē",
  metric_offline: "Bezsaistē",
  metric_ota_pending: "OTA gaida",
  metric_battery_warn: "Zems akumulators",
  metric_doors_open: "Atvērtas durvis",
  metric_windows_open: "Atvērti logi",
  metric_signal_avg: "Vidējais signāls",
  metric_last_comm: "Pēdējā komunikācija",
  metric_packets: "Paketes / h",
  view_all: "Skatīt visu",
  status_new: "Jauns",
  status_acknowledged: "Apstiprināts",
  status_resolved: "Atrisināts",
  status_resolved_local: "Atrisināts (lokāli)",
  resolve: "Atrisināt",
  add_note: "Pievienot piezīmi",
  save_note: "Saglabāt piezīmi",
  resolve_local_badge: "tikai šajā ierīcē",
  resolve_local_hint: "Atzīmē brīdinājumu kā atrisinātu tikai šajā pārlūkā. Komandai un serverim tas joprojām ir atvērts.",
  note_placeholder: "Pievieno kontekstu komandai…",
  notes_count: "{n} piezīme(s)",
  device_detail: "Ierīces dati",
  device_diagnostics: "Diagnostika",
  device_firmware_history: "Programmatūras vēsture",
  device_ota_config: "OTA konfigurācija",
  device_ota_status: "OTA statuss",
  device_signal: "Signāla kvalitāte",
  device_mac: "MAC adrese",
  device_serial: "Sērijas numurs",
  fall_sensitivity: "Kritiena jutība",
  transmission_interval: "Pārraides intervāls",
  low_battery_threshold: "Zema akumulatora slieksnis",
  ota_idle: "Dīkstāvē",
  ota_pending: "Gaida",
  ota_deploying: "Izvieto",
  ota_failed: "Neizdevās",
  events_filter_severity: "Smagums",
  events_filter_room: "Telpa",
  events_filter_patient: "Pacients",
  events_filter_device: "Ierīce",
  severity_info: "Info",
  severity_warning: "Brīdinājums",
  severity_critical: "Kritisks",
  telegram_title: "Telegram brīdinājumi",
  telegram_desc: "Saņemiet Telegram brīdinājumus par pacientiem, kas jums piešķirti.",
  telegram_connect: "Pieslēgt Telegram",
  telegram_connected: "Telegram pieslēgts",
  telegram_connected_as: "Pieslēgts Telegram kā {name}",
  telegram_connect_success: "Telegram veiksmīgi pieslēgts",
  telegram_connect_error: "Neizdevās pieslēgt Telegram. Lūdzu, mēģiniet vēlreiz.",
  telegram_missing_bot: "Telegram bots nav konfigurēts.",
  telegram_disconnect: "Atvienot",
  telegram_disconnect_success: "Telegram atvienots.",
  telegram_disconnect_error: "Neizdevās atvienot Telegram. Lūdzu, mēģiniet vēlreiz.",
  telegram_already_linked: "Šis Telegram konts jau ir saistīts ar citu e2-care lietotāju.",
  telegram_switch_q: "Izmantot citu Telegram kontu?",
  telegram_switch_intro: "Telegram atceras, kurš konts ir pieteicies visās vietnēs. Lai izmantotu citu:",
  telegram_switch_step1: "Atveriet Telegram Web un izrakstieties no pašreizējā konta.",
  telegram_switch_step2: "Atgriezieties šeit un pārlādējiet zemāk esošo pogu, pēc tam piesakieties ar otru kontu.",
  telegram_open_web: "Atvērt Telegram Web",
  telegram_reload_widget: "Es izrakstījos — pārlādēt pogu",
  lang_autodetected_toast: "Atklāta jūsu valoda: {language}. To var mainīt iestatījumos.",
  admin_view_active: "Aktīvi",
  admin_view_archived: "Arhivēti",
  admin_restore: "Atjaunot",
  admin_restored: "Atjaunots.",
  admin_hard_delete: "Dzēst neatgriezeniski",
  admin_hard_delete_title: "Dzēst neatgriezeniski?",
  admin_hard_delete_confirm: "«{name}» tiks neatgriezeniski izdzēsts no datu bāzes. Šo darbību nevar atsaukt.",
  admin_hard_deleted: "Neatgriezeniski izdzēsts.",
  admin_no_archived: "Nav arhivētu vienumu.",
  language_desc: "Tiek izmantota lietotnes saskarnei un jūsu Telegram + push paziņojumiem.",
  language_saved: "Valoda atjaunināta.",
  language_error: "Neizdevās atjaunināt valodu. Lūdzu, mēģiniet vēlreiz.",
  admin_field_language: "Valoda",
  edit: "Rediģēt",
  generic_error: "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  caregiver_added: "Aprūpētājs pievienots.",
  caregiver_removed: "Aprūpētājs noņemts.",
  family_added: "Ģimenes loceklis pievienots.",
  family_removed: "Ģimenes loceklis noņemts.",
  menu: "Izvēlne",
  dl_companion_app: "Pavadošā lietotne",
  dl_hero_title: "E2 Care operētājsistēmai Android",
  dl_hero_sub: "Instalējiet pavadošo lietotni Moko aprīkotā tālrunī, lai pārsūtītu brīdinājumus, konfigurētu ierīces un uzturētu saikni ar savu aprūpes komandu — pat tad, kad informācijas panelis ir aizvērts.",
  dl_android_apk: "Android APK",
  dl_version_loading: "ielādē versiju…",
  dl_released: "Izlaists {date}",
  dl_download_apk: "Lejupielādēt APK",
  dl_unavailable: "Nav pieejams",
  dl_preparing: "Sagatavo…",
  dl_manifest_error: "Neizdevās ielādēt manifestu. Mēģiniet atsvaidzināt — ja problēma turpinās, būvēšanas serveris, iespējams, tiek atkārtoti izvietots.",
  dl_whats_new: "Kas jauns",
  dl_installing_title: "Instalēšana jūsu tālrunī",
  dl_step1: "Pieskarieties „Lejupielādēt APK“ augšā. Jūsu pārlūks var brīdināt, ka APK faili var kaitēt ierīcei — šis brīdinājums ir normāls jebkuram instalētājam, kas lejupielādēts ārpus Play Store.",
  dl_step2: "Atveriet lejupielādēto failu. Android pirmajā reizē lūgs atļaut instalēšanu no šī pārlūka — ieslēdziet atļauju un atgriezieties.",
  dl_step3: "Pieskarieties „Instalēt“, pēc tam „Atvērt“, kad tas ir pabeigts.",
  dl_step4: "Piesakieties ar saviem E2 Care akreditācijas datiem.",
  dl_iphone_note: "iPhone versija būs pieejama vēlāk. Pagaidām, lūdzu, izmantojiet tīmekļa informācijas paneli.",
  dl_back_to_dashboard: "Atpakaļ uz informācijas paneli",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Mainot organizāciju, tiek notīrīts pašreizējais istabas un pacienta piešķīrums.",
  admin_view_full: "Pilns saraksts",
  device_filter_assignment: "Piešķīrums",
  device_filter_patient: "Piešķirts pacientam",
  device_filter_room: "Piešķirts istabai",
  device_filter_unassigned: "Nepiešķirts",
  admin_all_orgs: "Visas organizācijas",
  pagination_prev: "Iepriekšējā",
  pagination_next: "Nākamā",
  pagination_per_page: "Vienā lapā",
  pagination_page_of: "Lapa {page} no {pages}",
  pagination_total: "Kopā {total}",
  event_charging: "Uzlāde sākta",
  event_sos_cancel: "SOS atcelts",
  event_call: "SOS zvans",
  device_personal_alarm: "Personīgā trauksme",
  device_charging: "Uzlādējas",
  device_location: "Atrašanās vieta",
  device_current_location: "Pašreizējā atrašanās vieta",
  device_no_location: "Atrašanās vieta vēl nav ziņota.",
  device_location_source: "Avots",
  device_location_updated: "Atjaunināts",
  device_track_1h: "1 h",
  device_track_24h: "24 h",
  device_track_7d: "7 d",
  device_track_last: "Pēdējā atrašanās vieta",
  device_located: "Atrasts",
  map_sos: "SOS trauksme",
  map_fall: "Konstatēts kritiens",
  map_current: "Pašreizējā pozīcija",
  alert_timeline: "Trauksmes laika josla",
  alert_trigger: "Izraisītājs",
  alert_calls: "Zvani",
  alert_view_timeline: "Skatīt laika joslu",
  alert_no_deliveries: "Paziņojumi vēl nav nosūtīti.",
  alert_cancelled_on_device: "SOS tika atcelts ierīcē — trauksme paliek atvērta, līdz aprūpētājs to atrisina.",
  call_answered: "Atbildēts",
  call_missed: "Neatbildēts",
  reopen: "Atkārtoti atvērt",
  reopened: "Trauksme atkārtoti atvērta",
  live: "Tiešraidē",
  nav_home: "Sākums",
  family_home_kicker: "Ģimenes skats",
  family_home_title: "Jūsu tuvinieki",
  family_greeting: "Sveiki",
  family_home_sub: "Mierīgs pārskats par to, kā katram klājas.",
  family_status_ok: "jūtas labi",
  family_status_attention: "nepieciešama uzmanība",
  family_all_calm: "Šobrīd viss ir mierīgi.",
  family_attention_sub: "Apskatīsim, kā viņam klājas — sīkāk zemāk.",
  family_last_seen: "pēdējoreiz redzēts",
  family_latest_alert: "Pēdējā trauksme",
  family_no_alerts: "Nav nesenu trauksmju — viss ir labi.",
  family_view_details: "Skatīt detaļas",
  family_no_device: "Personīgā trauksme vēl nav saistīta.",
  status_never_reported: "Nekad nav ziņojis",
  mv_title: "Kustība",
  mv_sub: "No {n} kustības sensora(-iem) · 5 minūšu logi",
  mvo_title: "Kustība vienā skatienā",
  mvs_moving: "{name} ir augšā un kustas",
  mvs_moving_sub: "Kustējās {when}",
  mvs_rest: "{name} atpūšas",
  mvs_rest_sub: "Pēdējo reizi kustējās {when}",
  mvs_rest_sub_none: "Pēdējās 30 dienās kustības nav",
  mvs_quiet: "{name}: nav kustības ilgāk nekā parasti",
  mvs_quiet_sub: "Kustības nav jau {dur}. Varbūt vērts piezvanīt.",
  mvs_short_quiet: "Ilgi kluss",
  mvs_room_moving: "Kāds kustas telpā {name}",
  mvs_room_rest: "{name} ir mierīgi",
  mvs_room_quiet: "Telpā {name} kustības nav ilgāk nekā parasti",
  mvs_sensor: "Kustības sensors nesūta datus",
  mvs_sensor_sub: "Tas attiecas uz sensoru, nevis uz {name}. Pēdējais signāls {when}.",
  mvs_nodata: "Kustības datu vēl nav",
  mvs_nodata_sub: "Kustības sensors vēl neko nav nosūtījis.",
  mvd_title: "Pēdējās 24 stundas",
  mvd_moving: "Kustas",
  mvd_resting: "Atpūšas",
  mvd_nosignal: "Nav signāla",
  mvd_night: "Nakts",
  mvd_now: "Tagad",
  mvn_title: "Pēdējās 7 naktis",
  mvn_last_night: "Pagājušajā naktī",
  mvn_last_short: "Vakar",
  mvn_calm: "Mierīga",
  mvn_restless: "Nemierīga",
  mvn_still: "Ļoti mierīga",
  mvn_silent: "Sensors kluss",
  mvn_nodata: "Nav datu",
  mvn_s_calm_none: "Mierīga nakts, kustības nebija no {from} līdz {to}.",
  mvn_s_calm_once: "Mierīga nakts, piecēlās vienreiz ap {at}.",
  mvn_s_calm_many: "Mierīga nakts, piecēlās {n} reizes, pirmo reizi ap {first}, pēdējo ap {last}.",
  mvn_s_restless: "Nemierīga nakts, piecēlās {n} reizes no {first} līdz {last}.",
  mvn_s_still: "Ļoti mierīga nakts, mazāk kustības nekā parasti. Garākā atpūta {dur}.",
  mvn_s_still_moved: "Ļoti mierīga nakts, kustējās tikai ap {at}. Garākā atpūta {dur}.",
  mvn_s_silent: "Sensors bija gandrīz kluss, tāpēc nevaram pateikt, kā pagāja nakts.",
  mvn_s_nodata: "Šai naktij kustības datu nav.",
  mv_state_moving: "Kustas",
  mv_state_still: "Atpūšas",
  mv_state_inactive: "Neaktīvs",
  mv_state_silent: "Sensors nesūta datus",
  mv_state_never: "Nekad nav ziņojis",
  mv_state_nodata: "Vēl nav datu",
  mv_state_no_sensor: "Nav kustības sensora",
  mv_last_movement: "Pēdējā kustība",
  mv_last_sample: "Sensora pēdējais signāls",
  mv_none_in_retention: "Nav pēdējo 30 dienu laikā",
  mv_silent_hint: "Nav datu vairāk nekā {min} min — pārbaudiet sensoru vai tā vārteju. Tā ir ierīces kļūme, nevis nekustīgums.",
  mv_inactive_hint: "Nav kustības vairāk nekā {min} min, lai gan sensors joprojām sūta datus.",
  mv_history: "Kustību vēsture",
  mv_history_empty: "Šajā periodā vēl nav kustību datu.",
  mv_not_reporting: "Nesūta datus",
  mv_no_movement: "Nav kustības",
  mv_detections: "kustību konstatējumi",
  mv_legend_motion: "Kustību konstatējumi",
  mv_legend_gap: "Nesūta datus",
  mv_retention_note: "Vēsture tiek glabāta 30 dienas",
  mv_strip_title: "Kustība tiešsaistē",
  mv_strip_sub: "{n} kustības sensors(-i)",
  mv_unassigned: "Nepiesaistīts sensors",
  admin_alerts_timezone: "Organizācijas laika josla",
  admin_alerts_timezone_invalid: "Izvēlieties derīgu IANA laika joslu.",
  admin_alerts_night_wrap_hint: "Nakts stundas ilgst no {start} līdz {end} nākamajā rītā ({tz}), t. i., pēc {start} vai pirms {end}.",
  admin_alerts_night_same_day_hint: "Nakts stundas ilgst no {start} līdz {end} tajā pašā dienā ({tz}).",
  admin_alerts_night_equal: "Sākums un beigas nevar būt vienā laikā.",
  admin_alerts_inactivity_label: "Neaktivitātes slieksnis",
  admin_alerts_inactivity_question: "Vai šis cilvēks ir kustējies? Minūtes bez kustības, pirms tas kļūst par trauksmes iemeslu.",
  admin_alerts_silence_label: "Ierīces klusuma slieksnis",
  admin_alerts_silence_question: "Vai šis sensors vēl sazinās? Minūtes bez neviena signāla, pirms to uzskata par ierīces kļūmi, nevis neaktīvu iemītnieku.",
  admin_alerts_minutes: "minūtes",
  admin_alerts_threshold_invalid: "Ievadiet veselu skaitli, lielāku par 0.",
  admin_alerts_thresholds_provisional: "Sākotnējās vērtības (180 / 30 min) vēl nav pielāgotas — pielāgojiet tās saviem iemītniekiem.",
  admin_tab_gateways: "Vārtejas",
  gw_title: "Vārtejas",
  gw_status_deactivated: "Deaktivizēta",
  gw_scope_pending: "Jūsu organizācijas vārtejas parādīsies šeit, kad būs ieviests sistēmas atjauninājums.",
  gw_none_for_org: "Šai organizācijai vēl nav piešķirta neviena vārteja.",
  gw_col_room: "Telpa",
  gw_unassigned: "Nepiešķirta",
  gw_never: "Nekad",
  gw_edit_title: "Rediģēt vārteju",
  gw_new_title: "Jauna vārteja",
  gw_super_field: "To var mainīt tikai superadministrators",
  gw_mac_invalid: "Ievadiet 12 heksadecimālas rakstzīmes, piem. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Aparatūras tips",
  gw_notes: "Piezīmes",
  gw_manage_sub: "BLE centrmezgli, kas pārsūta sensoru datus: stāvoklis, organizācija un telpa. Klusa vārteja padara klusus visus aiz tās esošos sensorus.",
  gw_filter_all: "Visas organizācijas",
  gw_new: "Jauna vārteja",
  gw_col_assignment: "Organizācija · Telpa",
  gw_backend_pending: "Tam vajadzīgs sistēmas atjauninājums, kas vēl nav ieviests.",
  gw_save_failed: "Saglabāt vārteju",
  gw_created: "Vārteja izveidota",
  gw_saved: "Vārteja saglabāta",
  gw_reactivated: "Vārteja atkal aktivizēta",
  gw_deactivated: "Vārteja deaktivizēta",
  gw_reactivate: "Aktivizēt atkal",
  gw_deactivate: "Deaktivizēt",
  gw_reactivate_title: "Atkal aktivizēt {name}?",
  gw_deactivate_title: "Deaktivizēt {name}?",
  gw_reactivate_desc: "Tā atkal tiks ieskaitīta stāvoklī un brīdinājumos.",
  gw_deactivate_desc: "Tā vairs netiek ieskaitīta stāvoklī un brīdinājumos. Vēsture saglabājas, un to var atkal aktivizēt jebkurā laikā.",
  gw_heard_title: "Dzirdamās ierīces",
  gw_heard_sub: "Sensori, ko šī vārteja pārsūtīja pēdējās 24 stundās.",
  gw_heard_none: "Pēdējās 24 stundās nav nevienas ierīces.",
  gw_heard_unknown: "Nezināmas ierīces",
  gw_msgs_short: "ziņ.",
  gw_avg: "vid.",
  gw_samples_short: "paraugi",
  gw_not_found: "Vārteja nav atrasta vai jums nav redzama.",
  gw_one: "Vārteja",
  gw_manage_link: "Pārvaldīt administrācijā",
  gw_rssi_range: "Signāla diapazons",
  gw_longest_gap: "Garākais pārtraukums",
  gw_config_push: "Pēdējā konfig. nosūtīšana",
  gw_sub: "BLE centrmezgli, kas pārsūta sensoru datus. Tikai lasīšanai — klusa vārteja liek izskatīties klusiem visiem tai piesaistītajiem sensoriem.",
  gw_super_only: "Vārteju statuss pieejams tikai superadministratoriem.",
  gw_load_failed: "Ielādēt vārtejas",
  gw_status_reporting: "Ziņo",
  gw_status_silent: "Klusa",
  gw_status_never_seen: "Nekad nav redzēta",
  gw_returned: "Atgriezās pēc {h} h pārtraukuma (beidzās {at})",
  gw_count_reporting: "{n} ziņo",
  gw_count_silent: "{n} klusas",
  gw_count_never: "{n} nekad nav redzētas",
  gw_count_deactivated: "deaktivizētas: {n}",
  gw_window: "Novecojusi pēc {h} h bez ziņojuma",
  gw_col_name: "Vārteja",
  gw_col_status: "Statuss",
  gw_col_msgs: "Ziņojumi 24 h",
  gw_col_discard: "Atmesti",
  gw_last_message: "Pēdējais ziņojums",
  gw_devices_seen: "Redzētās ierīces",
  gw_hours_active: "Aktīvās stundas",
  gw_unregistered_title: "Ziņo bez reģistrācijas",
  gw_unregistered_desc: "Šie identifikatori parādās vārteju aktivitātē, bet tiem nav ieraksta (piem., ierīce, kas ziņo ar IMEI). Abu avotu kopsummas pamatoti atšķiras.",
  nav_reports: "Atskaites",
  rep_night_title: "Nakts kopsavilkums",
  rep_night_desc: "Rīta kopsavilkums par katra iemītnieka kustību organizācijas nakts stundās un sensoru klusuma periodiem.",
  rep_last_night: "Pagājušā nakts",
  rep_nights_ago: "Pirms {n} naktīm",
  rep_policy_fallback: "noklusējuma nakts stundas (politika nav pieejama)",
  rep_movement: "Kustība",
  rep_windows: "{n} aktīvi 5 min logi",
  rep_no_movement: "Nav kustības",
  rep_first_movement: "Pirmā kustība",
  rep_longest_still: "Garākais nekustīguma posms",
  rep_silences: "Sensora klusums",
  rep_none: "Nav",
  rep_coverage: "{pct}% saņemts",
  rep_night_note: "Laiki norādīti organizācijas laika joslā. Nekustīgums tiek skaitīts tikai, kamēr sensors sūta datus; klusuma periodi, kas sasniedz klusuma slieksni, uzskaitīti atsevišķi.",
  dh_reporting_title: "Ziņošanas stāvoklis",
  dh_never_reported_desc: "Reģistrēta, bet nekad nav ziņojusi. Tā ir nepabeigta uzstādīšana, nevis bezsaistes ierīce.",
  dh_interval_still: "Izmērītais intervāls (miera stāvoklī)",
  dh_interval_moving: "Izmērītais intervāls (kustībā)",
  dh_interval_samples: "Mērījumu paraugi",
  dh_interval_unmeasured: "Vēl nav izmērīta intervāla — tiek piemērots organizācijas klusuma slieksnis.",
  dh_interval_note: "Intervāli tiek mērīti pēc saņemtajiem ziņojumiem, nevis konfigurētās vērtības.",
  rep_dur_h_min: "{h} h {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Kopīga istaba — var ietvert citu kustību",
  rep_no_data_night: "Šai naktij nav datu — sensors nesūtīja datus (vai vēl nebija uzstādīts).",
  nav_buildings: "Ēkas",
  imei_label: "IMEI",
  imei_hint: "15 cipari, uzdrukāti ierīces aizmugurē",
  imei_length: "IMEI ir 15 cipari",
  imei_invalid: "Šis IMEI nav derīgs. Pārbaudiet ciparus",
  imei_resident_note: "Trauksmes poga seko iemītniekam, tāpēc tā netiek piesaistīta istabai.",
  imei_online_hint: "Ierīce parādās tiešsaistē pēc pirmā dzīvības signāla, aptuveni 5 minūtes pēc ieslēgšanas.",
  forgot_link: "Aizmirsāt paroli? Klikšķiniet šeit",
  forgot_title: "Atiestatīt paroli",
  forgot_sub: "Ievadiet savu e-pastu, un mēs nosūtīsim saiti paroles atiestatīšanai.",
  forgot_submit: "Nosūtīt saiti",
  forgot_sent: "Ja šim e-pastam ir konts, mēs nosūtījām paroles atiestatīšanas saiti. Pārbaudiet iesūtni.",
  forgot_back: "← Atpakaļ uz pieteikšanos",
  reset_title: "Iestatīt jaunu paroli",
  reset_sub: "Izvēlieties jaunu paroli savam kontam.",
  reset_new_password: "Jaunā parole",
  reset_confirm_password: "Apstiprināt paroli",
  reset_hint: "Vismaz 8 rakstzīmes.",
  reset_submit: "Atjaunināt paroli",
  reset_success: "Parole atjaunināta. Pāradresē uz pieteikšanos…",
  reset_too_short: "Parolei jābūt vismaz 8 rakstzīmes garai.",
  reset_mismatch: "Paroles nesakrīt.",
  reset_no_token: "Šī saite ir nederīga vai trūkst. Pieprasiet jaunu pieteikšanās lapā.",
  reset_failed: "Šī saite ir nederīga vai beigusies. Pieprasiet jaunu.",
  admin_tab_device_types: "Ierīču tipi",
  admin_dt_title: "Ierīču tipi",
  admin_dt_sub: "Ierīču modeļu katalogs. Pārdēvējiet tipa attēlojamo nosaukumu — iekšējā atslēga, IoT kartējums un sinhronizācija nemainās.",
  admin_dt_col_label: "Attēlojamais nosaukums",
  admin_dt_col_key: "Iekšējā atslēga",
  admin_dt_col_category: "Kategorija",
  admin_dt_col_wearable: "Valkājama",
  admin_dt_col_ble_sync: "BLE sinhronizācija",
  admin_dt_col_ble_type_id: "BLE tipa ID",
  admin_dt_wearable_yes: "Valkā iemītnieks",
  admin_dt_wearable_no: "Stacionāra",
  admin_dt_ble_sync_on: "Nepieciešama",
  admin_dt_ble_sync_off: "Izslēgta",
  admin_dt_edit_label: "Labot nosaukumu",
  admin_dt_edit_title: "Pārdēvēt nosaukumu",
  admin_dt_edit_desc: "Mainās tikai cilvēkam lasāmais nosaukums. Ierīces, filtri un integrācijas turpina izmantot iekšējo atslēgu “{key}”.",
  admin_dt_label_saved: "Nosaukums atjaunināts.",
  admin_dt_label_required: "Nosaukums nevar būt tukšs.",
  admin_dt_load_failed: "Ielādēt ierīču tipus",
  admin_dt_save_failed: "Atjaunināt nosaukumu",
  admin_dt_readonly_hint: "Tikai superadministratori var pārdēvēt nosaukumus.",
  sensor_climate: "Klimats",
  sensor_temperature: "Temperatūra",
  sensor_humidity: "Mitrums",
  sensor_last_reading: "Pēdējais rādījums",
  sensor_history_title: "Temperatūra un mitrums (48 h)",
  sensor_history_empty_title: "Vēl nav rādījumu",
  sensor_history_empty_sub: "Piesaistiet šai istabai H4 Pro sensoru, lai redzētu klimata vēsturi.",
  admin_thresholds_title: "Sensoru sliekšņi",
  admin_thresholds_desc: "Temperatūras un mitruma trauksmes robežas šīs organizācijas H4 Pro sensoriem.",
  admin_thresholds_temp_min: "Min. temperatūra",
  admin_thresholds_temp_max: "Maks. temperatūra",
  admin_thresholds_hum_min: "Min. mitrums",
  admin_thresholds_hum_max: "Maks. mitrums",
  admin_thresholds_temp_invalid: "Min. temperatūrai jābūt zemākai par maks. temperatūru.",
  admin_thresholds_hum_invalid: "Min. mitrumam jābūt zemākam par maks. mitrumu.",
  admin_thresholds_hint: "Visi četri nav obligāti — atstājiet lauku tukšu, ja šai robežai trauksme nav vajadzīga.",
  admin_thresholds_cooldown: "Trauksmju pauze",
  admin_thresholds_cooldown_placeholder: "Noklusējums: 30 min",
  admin_thresholds_cooldown_help: "Minūtes starp atkārtotām sensora trauksmēm. Atstājiet tukšu sistēmas noklusējumam (30 min).",
  admin_thresholds_cooldown_invalid: "Pauzei jābūt veselam skaitlim, vismaz 1 minūtei.",
  admin_thresholds_saved: "Sliekšņi saglabāti.",
  admin_thresholds_load_failed: "Ielādēt sliekšņus",
  admin_thresholds_save_failed: "Saglabāt sliekšņus",
  room_activity_view_all: "Skatīt visus notikumus",
  role_super_admin: "Superadministrators",
  assign_device: "Piesaistīt ierīci",
  select_device: "Izvēlieties ierīci…",
  admin_patient_no_devices_assigned: "Nav piesaistītu ierīču.",
  admin_patient_no_wearables: "Šajā organizācijā nav pieejamu valkājamu ierīču.",
  admin_patient_device_reassign: "piesaistīt citam",
  recent_critical_alerts_title: "Nesenās kritiskās trauksmes",
  rooms_building_clear: "Notīrīt filtru",
  buildings_title: "Ēkas",
  buildings_sub: "Katra jūsu uzraudzītā ēka ar tās istabām, iemītniekiem un ierīcēm.",
  buildings_view_rooms: "Skatīt istabas",
  wt_title: "Nedēļas tendence",
  wt_desc: "Septiņas naktis blakus katram iemītniekam — vai kopīgai istabai —, lai pamanītu nemierīgas vai neparasti nekustīgas naktis.",
  wt_baseline_note: "katra nakts salīdzināta ar rindas 7 nakšu mediānu",
  wt_no_sensors: "Nevienam iemītniekam vēl nav kustības sensora.",
  wt_flag_restless: "Nemierīga",
  wt_flag_still: "Neparasti nekustīga",
  wt_flag_nodata: "Nav datu",
  wt_flag_silent: "Sensors gandrīz kluss",
  rep_sensor_silent: "Sensors ziņoja tikai {pct}% no šīs nakts. Pārtraukumi nozīmē, ka sensors pārstāja ziņot, nevis ka iemītnieks bija nekustīgs.",
  wt_legend_active: "Aktīvi 5 min logi",
  wt_legend_still: "Garākais nekustīgums (h)",
  fap_title: "Ģimenes locekļi var apstrādāt brīdinājumus",
  fap_desc: "Ja ieslēgts, ģimenes locekļi var apstiprināt, atrisināt, atkārtoti atvērt un komentēt savu iemītnieku brīdinājumus organizācijā {org}.",
  note_saved: "Piezīme saglabāta",
  event_device_silent: "Sensors nesūta datus",
  event_no_movement: "Nav kustības",
  event_no_rise: "Nav kustības pēc nakts",

  dur_lt_min: "mazāk nekā minūti",
  dur_min: "{m} min",
  dur_h: "{h} h",
  dur_h_min: "{h} h {m} min",
  am_fall: "Konstatēts kritiens",
  am_sos: "Nospiesta SOS poga",
  am_low_battery: "Ierīces akumulators gandrīz tukšs",
  am_low_battery_dev: "Zems akumulatora līmenis: {device}",
  am_door: "Durvis atvērtas",
  am_door_in: "Durvis atvērtas: {place}",
  am_door_in_detail: "Durvis atvērtas: {place} ({detail})",
  am_window: "Logs atvērts",
  am_window_in: "Logs atvērts: {place}",
  am_window_in_detail: "Logs atvērts: {place} ({detail})",
  am_silent: "Kustības sensors telpā {place} nesūta datus jau aptuveni {dur} — pārbaudiet barošanu vai vārteju",
  am_silent_nodur: "Kustības sensors telpā {place} pārstāja sūtīt datus — pārbaudiet barošanu vai vārteju",
  am_nomove: "Telpā {place} nav konstatēta kustība aptuveni {dur}",
  am_nomove_nodur: "Telpā {place} nav konstatēta kustība",
  am_norise: "Telpā {place} nav konstatēta kustība kopš nakts beigām (parasti augšā līdz {time})",
  am_norise_notime: "Telpā {place} nav konstatēta kustība kopš nakts beigām",
  amf_silent_res: "{name} kustības sensors nesūta datus kopš {time}, tāpēc kustība pašlaik netiek sekota.",
  amf_silent_room: "Kustības sensors telpā {place} nesūta datus kopš {time}, tāpēc kustība tur pašlaik netiek sekota.",
  amf_sensor_ok: "Sensors darbojas; tas vienkārši nav redzējis nevienu kustamies.",
  amf_team: "Aprūpes komanda ir brīdināta savā panelī.",
  amf_contact_device: "Jūs esat norādīts kā šīs ierīces kontaktpersona.",
  amf_contact_resident: "Jūs esat norādīts kā kontaktpersona: {name}.",
  al_tab_care: "Aprūpe",
  al_tab_maint: "Apkope",
  al_maint_hint: "Sensori, kas nesūta datus, un zemi akumulatori: tehnisks darbs, nevis aprūpes notikumi.",
  al_maint_empty: "Nav sensoru vai akumulatoru problēmu.",
  al_auto_closed: "Slēgts automātiski",
  al_auto_closed_reason: "Slēgts automātiski — {reason}",
  al_never_seen: "neviens to neredzēja pirms slēgšanas",
  al_resolved_by: "Atrisināja {name}",
  al_reason_movement: "kustība atsākās",
  al_reason_sensor: "sensors atkal sūta datus",
  al_admin_only_ack: "Šo brīdinājumu var apstrādāt tikai administrators, jo tas nav saistīts ar vienu iemītnieku.",
  why_title: "Kāpēc tas nostrādāja?",
  why_since_motion: "Kopš pēdējās kustības",
  why_since_sample: "Kopš sensora pēdējiem datiem",
  why_threshold: "Slieksnis",
  why_up_by: "Parasti augšā līdz",
  why_night: "Nakts logs",
  why_source: "Slieksni noteica",
  why_src_org: "šī organizācija",
  why_src_default: "noklusējuma vērtības",
  why_state: "Sensora stāvoklis",
  why_checked: "Pārbaudīts",
  why_approx: "Pārbaudes notiek ik pēc 5 minūtēm, tāpēc brīdinājumu laiki ir aptuveni.",
  mon_label: "Kustības uzraudzība",
  mon_active: "aktīva",
  mon_down: "nesūta datus",
  mon_down_since: "nesūta datus kopš {time}",
  admin_alerts_up_by_label: "Parasti augšā līdz",
  admin_alerts_up_by_question: "Ja starp nakts beigām un šo laiku kustība nav redzēta, tiek izveidots brīdinājums “nav kustības kopš nakts beigām”.",
  admin_alerts_up_by_invalid: "Jābūt vēlāk par nakts beigām ({end}): tā ir stunda, kad iemītnieki parasti ir augšā, pēc nakts.",
  admin_alerts_up_by_format: "Ievadiet laiku formātā HH:MM.",
  admin_alerts_escalation_label: "Informēt ģimeni par klusu sensoru pēc",
  admin_alerts_escalation_question: "Personāls klusu sensoru redz uzreiz. Ģimene tiek informēta tikai tad, ja pēc šī laika tas joprojām nav atrisināts (uzreiz, ja organizācijai nav aprūpētāju).",
  admin_alerts_cooldown_note: "Pēc brīdinājuma slēgšanas tas pats brīdinājums var atgriezties, kad slieksnis atkal tiek pārsniegts. Rīta brīdinājums nostrādā ne vairāk kā reizi dienā.",
  admin_alerts_stored_invalid: "Saglabātais laiks ({up}) nav pēc nakts beigām ({end}), tāpēc rīta brīdinājumi nevar darboties un šo politiku nevar saglabāt, kamēr tas nav izlabots.",
  admin_alerts_defaults_badge: "Noklusējuma vērtības",

  fap_auto_on: "Automātiski: ieslēgts, jo šai organizācijai nav aprūpētāju.",
  fap_auto_off: "Automātiski: izslēgts, jo šai organizācijai ir aprūpētāji.",
  fap_manual: "Iestatījis administrators.",
  fap_reset: "Atpakaļ uz automātisko",
  fap_saved: "Saglabāts",
  fap_save_failed: "Neizdevās saglabāt. Mēģiniet vēlreiz.",
  fap_pending: "Drīzumā",
  fap_retry: "Mēģināt vēlreiz",
  recap_title: "Rīta nakts kopsavilkums",
  recap_desc_staff: "Katru dienu 07:00 (organizācijas laikā) pagājušās nakts kopsavilkums par katru jūsu organizācijas iemītnieku.",
  recap_desc_family: "Katru dienu 07:00 (organizācijas laikā) pagājušās nakts kopsavilkums par jūsu tuviniekiem.",
  recap_on: "Ieslēgts",
  recap_off: "Izslēgts",
  recap_email: "E-pasts",
  recap_telegram_link_first: "Pievienojiet Telegram augstāk, lai saņemtu to tur.",
  recap_no_channel: "Izvēlieties vismaz vienu kanālu, citādi nekas netiks nosūtīts.",
  recap_last_sent: "Pēdējo reizi nosūtīts {at}",
  recap_saved: "Iestatījumi saglabāti.",
  recap_save_failed: "Neizdevās saglabāt iestatījumus.",
  recap_unavailable: "Drīzumā",
  topbar_org_label: "Organizācija",
  device_ota_phase2: "OTA izvietošana kļūs interaktīva 2. fāzē.",
  event_window_open: "Logs atvērts",
  event_window_close: "Logs aizvērts",
  event_alarm_end: "Trauksme beigusies",
  wt_h: "h",
  wt_load_failed: "Neizdevās ielādēt kustību vēsturi. Mēģiniet vēlāk.",
  recap_load_failed: "Neizdevās ielādēt iestatījumus — pieskarieties, lai mēģinātu vēlreiz.",
  mv_shared_note: "Šis iemītnieks dala istabu. Istabas sensors nevar atšķirt iemītniekus, tāpēc kustība tiek rādīta istabai, nevis vienai personai.",
  mv_shared_link: "Skatīt kustību: {room}",
  mv_room_shared_note: "Kopīga {n} iemītniekiem — šo kustību nevar piedēvēt nevienam no viņiem.",
  rep_shared_room_row: "Kopīga istaba · {names}",
  admin_motion_resident: "Iemītnieka gultas sensors",
  admin_motion_resident_hint: "Nav obligāti. Izvēlieties iemītnieku tikai tad, ja sensors uzrauga viņa personīgo zonu (piem., vērsts uz gultu). Tad viņa kustību grafiki to izmantos arī kopīgā istabā.",
  admin_motion_whole_room: "Visa istaba",
};
export default lv;
